import * as React from "react";
import { useId } from "@react-aria/utils";
import { Select } from "../Select";
import { cx } from "../../helpers/utils/cx";
function valueToSelectOption(value) {
  return {
    value,
    title: String(value)
  };
}
export function PaginationOptions(_ref) {
  let {
    options,
    value,
    onChange,
    label = "Per page:"
  } = _ref;
  const selectId = useId();
  const selectOptions = React.useMemo(() => options.map(valueToSelectOption), [options]);
  const selectedOption = React.useMemo(() => valueToSelectOption(value), [value]);
  const onSelectChange = React.useCallback(option => {
    if (!Array.isArray(option)) {
      onChange(option?.value);
    }
  }, [onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-3 items-center", "text-primary")
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: selectId,
    className: cx("bolt-font-body-s-regular text-secondary")
  }, typeof label === "function" ? label() : label), /*#__PURE__*/React.createElement("div", {
    className: cx("w-20")
  }, /*#__PURE__*/React.createElement(Select, {
    id: selectId,
    options: selectOptions,
    value: selectedOption,
    onChange: onSelectChange,
    fullWidth: true,
    size: "sm",
    clearable: false
  })));
}